/* ==================================================================
   HIGH AS — MENU MOVIL (pareja de high-as-fix7/8/9/10.css)

   Hace cinco cosas:
     1) --ha-drawer-top = donde termina #header-group, para que el
        cajon se abra justo debajo de la cabecera.
     2) Inyecta la fila "Mi cuenta" en la barra de abajo del cajon.
     3) Mete ahi debajo el selector de pais/divisa.
     4) Marca <html class="ha-drawer-open"> mientras esta abierto.
     5) Pinta la hamburguesa / X.

   ⚠ DE DONDE SALE EL SELECTOR (punto 3) — DOS INTENTOS:
     1. El del propio cajon de Horizon: depende del ajuste
        "show_country" de la cabecera, y ese MISMO ajuste mete la
        pastilla "EUR" en la barra del escritorio, que no se quiere.
        Ademas, con el encendido, en el cajon tampoco aparecia.
     2. Clonar el del footer (.ha-foot__loc): tampoco. Ese bloque
        depende de un ajuste de la seccion del footer y no siempre
        esta en la pagina, asi que la copia no llegaba a hacerse.
     AHORA se genera en layout/theme.liquid dentro de un <template>
     con id "ha-loc-template", con los datos de Shopify. No depende
     de ningun ajuste ni de que exista otro bloque en la pagina.
     Se deja el clonado del footer como plan B por si alguien quita
     la plantilla.

   ⚠ HISTORIAL DEL PINTADO (punto 5) — CINCO INTENTOS:
     1. No es el SVG: los dos usan currentColor.
     2. No es el :hover: con el cajon abierto el boton no lo recibe.
     3. Por CSS ganaba siempre algun !important de las hojas fix;
        por eso el color va EN LINEA con prioridad !important.
     4. querySelector cogia el primer boton de menu, que esta
        oculto: hay MAS DE UNO. Hay que recorrerlos todos.
     5. Al recorrerlos, 'header-drawer summary' cogia tambien el
        "Tienda" del menu. Ahora se excluye lo que este dentro de
        .menu-drawer.

   PARA REVERTIR: borrar la linea de este archivo en
   layout/theme.liquid, las de high-as-fix7/8/9/10.css y la
   plantilla #ha-loc-template del final del <body>.
   ================================================================== */
(function () {
  if (window.__haMenuMovil) return;
  window.__haMenuMovil = true;

  var BLANCO = '#ffffff';
  var NARANJA = '#e9622c';
  var AMBAR = '#f2900f';

  var raf = 0;
  var hovered = false;

  function drawers() {
    return Array.prototype.slice.call(document.querySelectorAll('.menu-drawer-container'));
  }

  /* Solo el boton de la BARRA. Se excluye lo que este dentro del
     cajon: ahi viven los <summary> de "Tienda" y del pais. */
  function burgers() {
    var all = document.querySelectorAll('#header-group .header__icon--menu, #header-group .header__icon--summary');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('.menu-drawer')) out.push(all[i]);
    }
    return out;
  }

  function isOpen() {
    var list = drawers();
    for (var i = 0; i < list.length; i++) {
      if (list[i].hasAttribute('open')) return true;
    }
    return false;
  }

  /* ---- 1. Donde termina la cabecera ---- */
  function setDrawerTop() {
    var hg = document.getElementById('header-group');
    if (!hg) return;
    var bottom = hg.getBoundingClientRect().bottom;
    if (!(bottom > 0)) bottom = 0;
    document.documentElement.style.setProperty('--ha-drawer-top', Math.round(bottom) + 'px');
  }

  /* Con el cajon abierto NO se recalcula: el bloqueo de scroll puede
     mover la pagina y dejaba la medida mal en la segunda apertura. */
  function queueDrawerTop() {
    if (isOpen() || raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = 0;
      setDrawerTop();
    });
  }

  /* ---- 5. Color del icono, en linea y con !important ---- */
  function paint() {
    var open = isOpen();
    var color = BLANCO;
    if (open) color = hovered ? AMBAR : NARANJA;
    else if (hovered) color = NARANJA;

    var list = burgers();
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      var nodes = [btn].concat(Array.prototype.slice.call(btn.querySelectorAll('*')));
      for (var j = 0; j < nodes.length; j++) {
        nodes[j].style.setProperty('color', color, 'important');
      }
    }
  }

  function sync() {
    document.documentElement.classList.toggle('ha-drawer-open', isOpen());
    paint();
  }

  /* ---- 2. Fila "Mi cuenta" ----
     /account lleva al login si no has entrado y a la cuenta si ya
     estas dentro, asi que vale para los dos casos. */
  function addAccountRows() {
    var boxes = document.querySelectorAll('.menu-drawer__utility-links');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.querySelector('.ha-drawer-account')) continue;

      var link = document.createElement('a');
      link.className = 'ha-drawer-account';
      link.href = '/account';
      link.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<circle cx="12" cy="8" r="3.6"></circle>' +
        '<path d="M4.5 20.5c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6"></path>' +
        '</svg><span>' + ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'My account' :
          (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0 ? 'Mein Konto' :
          (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0 ? 'Mon compte' :
          (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0 ? 'Il mio account' :
          'Mi cuenta') + '</span>';

      box.insertBefore(link, box.firstChild);
    }
  }

  /* ---- 3. Pais / divisa ---- */
  function bindLoc(root) {
    var trigger = root.querySelector('.ha-loc-trigger');
    var pop = root.querySelector('.ha-loc-pop');
    var search = root.querySelector('.ha-loc-search');
    var items = root.querySelectorAll('.ha-loc-item');
    var inputName = root.classList.contains('ha-drawer-language') ? 'language_code' : 'country_code';
    var input = root.querySelector('input[name="' + inputName + '"]');
    var form = root.querySelector('form');
    if (!trigger || !pop) return;

    function filt(q) {
      for (var i = 0; i < items.length; i++) {
        var n = items[i].getAttribute('data-name') || '';
        items[i].style.display = n.indexOf(q) > -1 ? '' : 'none';
      }
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var abierto = !pop.hidden;

      var drawer = root.closest('.menu-drawer__utility-links') || document;
      var allPops = drawer.querySelectorAll('.ha-drawer-loc .ha-loc-pop');
      var allTriggers = drawer.querySelectorAll('.ha-drawer-loc .ha-loc-trigger');
      for (var p = 0; p < allPops.length; p++) allPops[p].hidden = true;
      for (var t = 0; t < allTriggers.length; t++) allTriggers[t].setAttribute('aria-expanded', 'false');

      pop.hidden = abierto;
      trigger.setAttribute('aria-expanded', String(!abierto));
      if (!abierto && search) {
        search.value = '';
        filt('');
        window.setTimeout(function () { search.focus(); }, 30);
      }
    });

    if (search) {
      search.addEventListener('input', function () { filt(this.value.toLowerCase()); });
      search.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('click', function () {
        if (input) input.value = this.getAttribute('data-code');
        if (form) {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        pop.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Primero la plantilla de theme.liquid; si no estuviera, se intenta
     copiar la del footer. */
  function makeLoc(index) {
    var tpl = document.getElementById('ha-loc-template');
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      var fromTpl = tpl.content.firstElementChild.cloneNode(true);
      var f1 = fromTpl.querySelector('form');
      if (f1) f1.setAttribute('id', 'ha-loc-form-drawer-' + index);
      return fromTpl;
    }

    var src = document.querySelector('.ha-foot__loc:not(.ha-drawer-loc)');
    if (!src) return null;
    var clone = src.cloneNode(true);
    clone.className = 'ha-foot__loc ha-drawer-loc';
    var inp = clone.querySelector('input[name="country_code"]');
    if (inp) inp.removeAttribute('id');
    var f2 = clone.querySelector('form');
    if (f2) f2.setAttribute('id', 'ha-loc-form-drawer-' + index);
    var label = clone.querySelector('.ha-foot__loc-label');
    if (label && label.parentNode) label.parentNode.removeChild(label);
    return clone;
  }

  function addLocalization() {
    var boxes = document.querySelectorAll('.menu-drawer__utility-links');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.querySelector('.ha-drawer-loc')) continue;

      var node = makeLoc(i);
      if (!node) continue;

      var pop = node.querySelector('.ha-loc-pop');
      if (pop) pop.hidden = true;

      box.appendChild(node);
      var locs = node.querySelectorAll('.ha-drawer-loc');
      for (var j = 0; j < locs.length; j++) bindLoc(locs[j]);
    }
  }

  /* El texto del enlace padre navega; la flecha y el resto de la
     fila conservan el comportamiento de acordeon. Evita el doble toque,
     que en movil es poco fiable y dificil de descubrir. */
  function bindParentMenuLinks() {
    var summaries = document.querySelectorAll('.menu-drawer summary[data-parent-url]');
    for (var i = 0; i < summaries.length; i++) {
      var summary = summaries[i];
      if (summary.dataset.haParentLink === '1') continue;
      summary.dataset.haParentLink = '1';

      var text = summary.querySelector('.menu-drawer__menu-item-text');
      var url = summary.getAttribute('data-parent-url');
      if (!text || !url) continue;

      text.setAttribute('role', 'link');
      text.setAttribute('tabindex', '0');

      (function (label, destination) {
        function go(e) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = destination;
        }
        label.addEventListener('click', go);
        label.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') go(e);
        });
      })(text, url);
    }
  }

  function bindBurgers() {
    var list = burgers();
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      if (btn.dataset.haPaint === '1') continue;
      btn.dataset.haPaint = '1';
      btn.addEventListener('mouseenter', function () { hovered = true; paint(); });
      btn.addEventListener('mouseleave', function () { hovered = false; paint(); });
    }
  }

  function bindDrawers() {
    var list = drawers();
    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      if (d.dataset.haDrawer === '1') continue;
      d.dataset.haDrawer = '1';

      (function (node) {
        node.addEventListener('toggle', function () {
          if (node.hasAttribute('open')) {
            setDrawerTop();
            window.setTimeout(setDrawerTop, 60);
          }
          addAccountRows();
          addLocalization();
          sync();
        });

        if (window.MutationObserver) {
          new MutationObserver(sync).observe(node, {
            attributes: true,
            attributeFilter: ['open']
          });
        }
      })(d);
    }
  }

  function init() {
    setDrawerTop();
    addAccountRows();
    addLocalization();
    bindParentMenuLinks();
    bindBurgers();
    bindDrawers();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El cajon puede montarse tarde (Horizon lo re-renderiza). Se
     reintenta unas cuantas veces sin coste apreciable. */
  var tries = 0;
  var timer = window.setInterval(function () {
    tries++;
    addAccountRows();
    addLocalization();
    bindParentMenuLinks();
    if (tries > 12) window.clearInterval(timer);
  }, 400);

  window.addEventListener('resize', queueDrawerTop, { passive: true });
  window.addEventListener('orientationchange', queueDrawerTop, { passive: true });
  window.addEventListener('scroll', queueDrawerTop, { passive: true });

  document.addEventListener('shopify:section:load', init);
})();
